// Phase 70H — Reusable grouped category picker.
//
// v3.19.4: the same props, but now a searchable combobox (see
// CategoryCombobox). The taxonomy is ~60 leaves and users were scrolling the
// whole list to find one. Every call site — Transactions, the transaction
// drawer, bulk edit, recurring commitments, learn-rule, receipt scan — picks
// this up unchanged.
//
// Usage:
//   <CategorySelect
//     type={form.type}             // 'expense' | 'income' | 'investment' | 'transfer' | 'refund'
//     value={form.category}
//     onChange={(v) => setForm({ ...form, category: v })}
//     placeholder="Pick one"
//     triggerClassName="rounded-xl"        // optional
//     testId="transaction-category-select" // optional
//     disabled={false}                     // optional
//   />
//
// Keeps a leaf-only string in form state — the DB still sees the same flat
// category string it always has. Groups are a UI concern only.
import React, { useMemo } from 'react';
import { CategoryCombobox } from '@/components/CategoryCombobox';
import { categoryGroupsForType } from '@/lib/categorize';

export function CategorySelect({
  type = 'expense',
  value,
  onChange,
  placeholder = 'Pick one',
  triggerClassName,
  contentClassName,
  testId,
  disabled = false,
  id,
}) {
  const groups = useMemo(() => categoryGroupsForType(type), [type]);

  return (
    <CategoryCombobox
      id={id}
      groups={groups}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      // Only this transaction type's categories are listed, so say so rather
      // than implying the user mistyped.
      emptyHint={`Only ${type} categories are listed — change the type above to see the others.`}
      triggerClassName={triggerClassName}
      contentClassName={contentClassName}
      testId={testId}
      disabled={disabled}
    />
  );
}

export default CategorySelect;
